import {
  TADARIDA_SESSION_PERSIST_KEY,
  USER_PERSIST_KEY,
  useSessionId,
  useUser,
} from '@aboutyou/user';
import {useEffect} from 'react';

export const SyncSessionBetweenTabs = () => {
  const {data, updateCache} = useSessionId();
  const {data: user, updateCache: updateUserCache} = useUser();

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    const storageListener = (event: StorageEvent) => {
      if (event.key === TADARIDA_SESSION_PERSIST_KEY) {
        const newValue = event.newValue ? JSON.parse(event.newValue) : null;
        if (newValue && newValue.sessionId !== data?.sessionId) {
          // eslint-disable-next-line local-rules/set-state-in-use-effect
          updateCache(newValue);
        }
      }

      if (event.key === USER_PERSIST_KEY) {
        const newValue = event.newValue ? JSON.parse(event.newValue) : null;
        if (newValue && JSON.stringify(newValue) !== JSON.stringify(user)) {
          // eslint-disable-next-line local-rules/set-state-in-use-effect
          updateUserCache(newValue);
        } else if (!newValue) {
          // if value send is falsy and event was sent. We can presume user changed state from logged in to logged out
          // in that case we want to reload page
          window.location.reload();
        }
      }
    };

    window.addEventListener('storage', storageListener);

    return () => {
      window.removeEventListener('storage', storageListener);
    };
  }, [data]);

  return null;
};
